
<ng-container >
  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="material-icons-outlined">all_inbox</span>
        {{'EMAI_LOG.CONT_MOD.TAB_TIT1' | translate}}
      </ng-template>
        <ng-container *ngIf="cargandoLogStatus">
          <div fxLayout="column" fxLayoutAlign="center center" style="margin-top:30px" >
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h1>{{'EMAI_LOG.CONT_MOD.TEX_CHA_INFO_GRAL' | translate}}</h1>
          </div>
        </ng-container>
      <ng-container *ngIf="!cargandoLogStatus">
        <!-- <h2>Lista correos tipo de correo :</h2> -->
        <div class="" fxLayout="row" fxLayoutAlign="space-between start">
          <div class="border" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="30" style="height: 630px; overflow-y: scroll;">
            <div class="cardMargin" fxLayout="column" >
              <mat-card *ngFor="let logEsta of logEstatus;let i=index" (click)="infoEmail(i,logEsta)" style="cursor: pointer" [ngClass]="{'desactivado':!logEsta.activo, 'activado': logEsta.activo}">
                <div class="" fxLayout="column" >
                  <div class="" fxLayout="row">
                    <span class="material-icons-outlined" style="margin-right:20px">{{nameTipoIconEmail}}</span>
                    {{logEsta.fecha|date:'d MMM y H:mm':offsetPipe:idiomaActual}}
                  </div>
                  <div class="" fxLayout="column">
                    <span>{{'EMAI_LOG.CONT_MOD.TEX_ASUN' | translate}} {{logEsta.asunto}} </span>
                  </div>
                </div>

                <mat-card-subtitle></mat-card-subtitle>
              </mat-card>
            </div>

          </div>
          <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="65" style="height: 630px; overflow-y: scroll;">
            <ng-container *ngIf="emailHistori==''">
              <div class="statusDivAlert" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" fxFlex="90">
                <div class="roundEdg alert mat-elevation-z4 pr-20 pl-20 font-size-24 font-weight-300 line-height-1" fxLayout="row" fxLayoutAlign="space-between center">
                  <h2>{{'EMAI_LOG.CONT_MOD.TEX_SELEC_EMA' | translate}}</h2>
                  <mat-icon class="ml-20 s-40">warning</mat-icon>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="cargandoInfoEmail">
              <div fxLayout="column" fxLayoutAlign="space-between center" style="margin-top:30px" >
                <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                <h1>{{'EMAI_LOG.CONT_MOD.TEX_CHA_INFO_EMA' | translate}}</h1>
              </div>
            </ng-container>
            <ng-container *ngIf="!cargandoInfoEmail">
              <ng-container *ngIf="emailHistori!=''">
                <div class="" fxLayout="column">
                  <h1 style="margin-left: 15px;">{{'EMAI_LOG.CONT_MOD.H1_TIT_EMA_INFO' | translate}}</h1>
                  <span style="margin-left: 15px;">{{'EMAI_LOG.CONT_MOD.SPAN_SUB_TIT_DET' | translate}}</span>
                  <mat-list role="list" class="listInforation">
                    <mat-list-item role="listitem">
                      <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="titulosInformation">{{'EMAI_LOG.CONT_MOD.TO' | translate}}</span>
                        <h3 style="margin-left:20px"> {{emailHistori.to}}</h3>
                      </div>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item role="listitem">
                      <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="titulosInformation">{{'EMAI_LOG.CONT_MOD.FROM' | translate}}  </span>
                        <h3 style="margin-left:20px"> {{emailHistori.from}}</h3>
                      </div>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item role="listitem">
                      <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="titulosInformation">{{'EMAI_LOG.CONT_MOD.SUBJE' | translate}}  </span>
                        <h3 style="margin-left:20px">{{emailHistori.asunto}}</h3>
                      </div>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <ng-container *ngIf="mostrarMas">
                      <!-- <mat-list-item role="listitem">
                        <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                          <span class="titulosInformation">API Key  </span>
                          <h3 style="margin-left:20px"> itbmMail sender </h3>
                        </div>
                      </mat-list-item> -->
                      <mat-divider></mat-divider>
                      <mat-list-item role="listitem">
                        <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                          <span class="titulosInformation"> {{'EMAI_LOG.CONT_MOD.MESS_ID' | translate}}  </span>
                          <h3 style="margin-left:20px"> {{emailHistori.sg_message_id}}</h3>
                        </div>
                      </mat-list-item>
                      <!-- <mat-divider></mat-divider>
                        <mat-list-item role="listitem">
                          <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                            <span class="titulosInformation"> Sending IP Address</span>
                            <h3 style="margin-left:20px"> 192.168.1.10</h3>
                          </div>
                        </mat-list-item>
                        <mat-divider></mat-divider> -->
                      </ng-container>
                      <div class="" fxLayout="column" fxLayoutAlign="end center">
                        <button mat-button color="primary" *ngIf="!mostrarMas" (click)="verDatosInformation()" class="btnVermas">{{'EMAI_LOG.CONT_MOD.BTN_VER_MAS' | translate}}</button>
                        <button mat-button color="primary" *ngIf="mostrarMas" (click)="verDatosInformation()" class="btnVermas">{{'EMAI_LOG.CONT_MOD.BTN_VER_MEN' | translate}}</button>
                      </div>
                    </mat-list>
                  </div>
                  <div class="" fxLayout="column">
                    <h1 style="margin-left: 15px;">{{'EMAI_LOG.CONT_MOD.TIT_TEX_LIS' | translate}}</h1>
                    <mat-list role="list" class="listInforation" *ngIf="eventDropped.length>0">
                      <mat-accordion>
                        <mat-expansion-panel (opened)="panelOpenState = true"
                        (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <span class="material-icons-outlined" style="margin-top:15px; color:#e40601 ">dangerous</span> <h3>{{'EMAI_LOG.CONT_MOD.'+eventDropped[0].Event | translate}}</h3>
                          </mat-panel-title>
                          <mat-panel-description>
                            <h3>{{eventDropped[0].fechaActualNueva|date:'d MMM y H:mm':offsetPipe:idiomaActual}}{{eventDropped[0].fechaActualNueva|date:'z':offsetPipe:idiomaActual}}</h3>
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <ng-container *ngIf="eventDropped[0].reason=='Bounced Address'">
                          <p>{{'EMAI_LOG.CONT_MOD.REASON.'+ eventDropped[0].reason | translate}}</p>
                        </ng-container>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <!-- <mat-list-item role="listitem">
                      <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                        <span >we sent the email </span>
                      </div>
                    </mat-list-item> -->
                  </mat-list>

                  <mat-list role="list" class="listInforation" *ngIf="eventProcessed.length>0 || eventDeferred.length>0">
                    <mat-list-item role="listitem">
                      <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="material-icons-outlined" id="developer_board"> developer_board </span>
                        <span class="titulosInformation">{{'EMAI_LOG.CONT_MOD.SPAN_RECIV_SENGR' | translate}}</span>
                      </div>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-accordion *ngIf="eventProcessed.length>0">
                      <mat-expansion-panel (opened)="panelOpenState = true"
                      (closed)="panelOpenState = false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span class="material-icons-outlined" style="margin-top:15px; color:#62F136">check_circle</span> <h3>{{'EMAI_LOG.CONT_MOD.'+eventProcessed[0].Event | translate}}</h3>
                        </mat-panel-title>
                        <mat-panel-description>
                          <h3>{{eventProcessed[0].fechaActualNueva|date:'d MMM y H:mm':offsetPipe:idiomaActual}}{{eventProcessed[0].fechaActualNueva|date:'z':offsetPipe:idiomaActual}}</h3>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <!-- <p>I'm visible because I am open</p> -->
                    </mat-expansion-panel>
                  </mat-accordion>
                  <mat-divider></mat-divider>
                  <mat-accordion *ngIf="eventDeferred.length>0">
                      <mat-expansion-panel (opened)="panelOpenState = true"
                      (closed)="panelOpenState = false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span class="material-icons-outlined" style="margin-top:15px; color:#ECE61E">remove_circle_outline</span> <h3>{{'EMAI_LOG.CONT_MOD.'+eventDeferred[0].Event | translate}} (Attempt #{{uiltimoEventDeferred.Attempt}})</h3>
                        </mat-panel-title>
                        <mat-panel-description>
                          <h3>{{uiltimoEventDeferred.fechaActualNueva|date:'d MMM y H:mm':offsetPipe:idiomaActual}}{{uiltimoEventDeferred.fechaActualNueva|date:'z':offsetPipe:idiomaActual}}</h3>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div class="" fxLayout="column" fxLayoutAlign="start start">
                        <!-- <h1>Latestrespons:</h1> -->
                        <p>Response:{{uiltimoEventDeferred.response}}</p>
                      </div>
                    <mat-list role="list" *ngIf='mostrarMasDefere'  class="listInforation">
                      <mat-list-item  *ngFor="let eventDefe of eventDeferred;let i = index" >
                        <h4 style="margin-right:5px;">Response at {{eventDefe.fechaActualNueva|date:'d MMM y H:mm':offsetPipe:idiomaActual}}</h4>
                        <p>{{eventDefe.response}}</p>
                        <mat-divider></mat-divider>
                      </mat-list-item>
                    </mat-list>
                    <div class="" fxLayout="column" fxLayoutAlign="end center">
                      <button mat-button color="primary" *ngIf="!mostrarMasDefere" (click)="vermostrarMasDefere()" class="btnVermas">{{'EMAI_LOG.CONT_MOD.BTN_VER_MAS' | translate}}</button>
                      <button mat-button color="primary" *ngIf="mostrarMasDefere" (click)="vermostrarMasDefere()" class="btnVermas">{{'EMAI_LOG.CONT_MOD.BTN_VER_MEN' | translate}}</button>
                    </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </mat-list>
                <mat-divider  [vertical]="true"  style="height:40px;width: 50px;"></mat-divider>
                <mat-list role="list" class="listInforation" *ngIf="eventBounce.length>0">
                  <mat-list-item role="listitem">
                    <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                      <span class="material-icons-outlined" id="developer_board"> developer_board </span>
                      <span class="titulosInformation">Bounce</span>
                    </div>
                  </mat-list-item>
                  <mat-divider></mat-divider>
                  <mat-accordion>
                    <mat-expansion-panel (opened)="panelOpenState = true"
                    (closed)="panelOpenState = false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <span class="material-icons-outlined" style="margin-top:15px; color:#e40601 ">dangerous</span> <h3>{{'EMAI_LOG.CONT_MOD.'+eventBounce[0].type | translate}}</h3>
                      </mat-panel-title>
                      <mat-panel-description>
                        <h3>{{eventBounce[0].fechaActualNueva|date:'d MMM y H:mm':offsetPipe:idiomaActual}}{{eventBounce[0].fechaActualNueva|date:'z':offsetPipe:idiomaActual}}</h3>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <p>Rason: {{eventBounce[0].reason}}</p>
                  </mat-expansion-panel>
                </mat-accordion>
              </mat-list>
              <mat-divider  [vertical]="true"  style="height:40px;width: 50px;"></mat-divider>
              <mat-list role="list" class="listInforation" *ngIf="eventDelivered.length>0">
                <!-- <mat-list-item role="listitem">
                  <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                    <span class="material-icons-outlined"> api </span>
                    <span class="titulosInformation">{{'EMAI_LOG.CONT_MOD.SPAN_RECIV_FROM' | translate}} {{emailHistori.to}}</span>
                  </div>
                </mat-list-item> -->
                <mat-divider></mat-divider>
                <mat-accordion>
                  <mat-expansion-panel (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <span class="material-icons-outlined" style="margin-top:15px; color:#62F136">check_circle</span> <h3>{{'EMAI_LOG.CONT_MOD.'+eventDelivered[0].Event | translate}}</h3>
                    </mat-panel-title>
                    <mat-panel-description>
                      <h3>{{eventDelivered[0].fechaActualNueva|date:'d MMM y H:mm':offsetPipe:idiomaActual}} {{eventDelivered[0].fechaActualNueva|date:'z':offsetPipe:idiomaActual}}</h3>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <p>{{eventDelivered[0].response}}</p>
                </mat-expansion-panel>
              </mat-accordion>
            </mat-list>
            <mat-divider  [vertical]="true"  style="height:40px;width: 50px;"></mat-divider>
            <mat-list role="list" class="listInforation" *ngIf="eventOpen.length>0">
              <mat-list-item role="listitem">
                <div class="" fxLayout="row" fxLayoutAlign="space-between center">
                  <span class="material-icons-outlined"> account_circle </span>
                  <span class="titulosInformation">{{'EMAI_LOG.CONT_MOD.SPAN_RECIV_FROM' | translate}} {{emailHistori.to}}</span>
                </div>
              </mat-list-item>
              <mat-divider></mat-divider>
              <ng-container *ngFor="let open of eventOpen;let i = index">
                <mat-accordion>
                  <mat-expansion-panel (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false" (click)="openActivity(i)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <span class="material-icons-outlined" style="margin-top:15px; color:#62F136">check_circle</span> <h3>{{'EMAI_LOG.CONT_MOD.'+open.Event | translate}}</h3>
                    </mat-panel-title>
                    <mat-panel-description>
                      <h3>{{open.fechaActualNueva|date:'d MMM y H:mm':offsetPipe:idiomaActual}} {{open.fechaActualNueva|date:'z':offsetPipe:idiomaActual}}</h3>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <!-- <p>{{openDetailsInfo}}</p> -->
                  <p>Event_ID :{{open.sg_event_id}}</p>
                </mat-expansion-panel>
              </mat-accordion>
              <mat-list role="list">
                <mat-list-item role="listitem" style="background-color:#D9D9DC">
                  <span>{{'EMAI_LOG.CONT_MOD.SPAN_DES_OPE_EMA' | translate}}</span>
                </mat-list-item>
              </mat-list>
            </ng-container>
          </mat-list>


        </div>
      </ng-container>
    </ng-container>
  </div>

        </div>
      </ng-container>

</mat-tab>

<mat-tab>
  <ng-template mat-tab-label>
    <span class="material-icons-outlined">preview</span>
    {{'EMAI_LOG.CONT_MOD.TAB_TIT2' | translate}}
  </ng-template>
  <ng-container *ngIf="cargandoLogStatus">
    <div fxLayout="column" fxLayoutAlign="center center" style="margin-top:30px">
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'EMAI_LOG.CONT_MOD.TEX_CHA_INFO_GRAL' | translate}}</h1>
    </div>
  </ng-container>
  <ng-container *ngIf="!cargandoLogStatus">
    <!-- <h2>Lista correos tipo de correo :</h2> -->
    <div class="" fxLayout="row" fxLayoutAlign="space-between start">
      <div class="border" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="30" style="height: 600px; overflow-y: scroll;">
        <div class="cardMargin" fxLayout="column" >
          <mat-card *ngFor="let logEmaPre of logEmailsPreview;let i=index" (click)="infoPreviewEmail(i,logEmaPre)" style="cursor: pointer" [ngClass]="{'desactivado':!logEmaPre.activo, 'activado': logEmaPre.activo}">
            <div class="" fxLayout="column" >
              <div class="" fxLayout="row">
                <span class="material-icons-outlined" style="margin-right:20px">{{nameTipoIconEmail}}</span>
                {{logEmaPre.sendingDate|date:'d MMM y H:mm':offsetPipe:idiomaActual}}
              </div>
              <div class="" fxLayout="column">
                <span>{{'EMAI_LOG.CONT_MOD.TEX_ASUN' | translate}} {{logEmaPre.asunto}} </span>
              </div>
            </div>

            <mat-card-subtitle></mat-card-subtitle>
          </mat-card>
        </div>
      </div>
      <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="65" style="height: 600px; overflow-y: scroll;">
        <ng-container *ngIf="emailData==''">
          <div class="statusDivAlert" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" fxFlex="90">
            <div class="roundEdg alert mat-elevation-z4 pr-20 pl-20 font-size-24 font-weight-300 line-height-1" fxLayout="row" fxLayoutAlign="space-between center">
              <h2>{{'EMAI_LOG.CONT_MOD.TEX_SELEC_EMA' | translate}}</h2>
              <mat-icon class="ml-20 s-40">warning</mat-icon>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="cargandoInfoPreviewEmail">
          <div fxLayout="column" fxLayoutAlign="space-between center" style="margin-top:30px">
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h1>{{'EMAI_LOG.CONT_MOD.TEX_CHA_INFO_EMA' | translate}}</h1>
          </div>
        </ng-container>
        <ng-container *ngIf="!cargandoInfoPreviewEmail && emailData!='' " >
          <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-top:15px">
            <mat-form-field fxFlex="100" >
              <mat-label>Asunto:</mat-label>
              <input matInput [(ngModel)]="emailData.asunto" disabled>
            </mat-form-field>
          </div>
          <editor apiKey="u44q4mabn60a95px2uqtgyeiml3ymlovuzb7ifgfgiwu1q34" [(ngModel)]="emailData.mail" #editorMce [init]="opciones"></editor>
        </ng-container>
      </div>
    </div>
  </ng-container>
</mat-tab>
</mat-tab-group>
</ng-container>
